export const newLine = '\u000A';
export const naText = 'N/A';
